"use client";
import React from "react";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

import { AppThemeProvider } from "@/components/AppThemeProvider";

type Props = {
  children: React.ReactNode;
};

const queryClient = new QueryClient();

const Providers = ({ children }: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>{children}</AppThemeProvider>
    </QueryClientProvider>
  );
};

export default Providers;
